import { useCallback, useEffect, useMemo, useState } from 'react'

export default function useRequesterSteps(initialStep) {
  const [steps, setSteps] = useState([])

  useEffect(() => setSteps([initialStep]), [initialStep])

  const onNext = useCallback((step) => setSteps([...steps, step]), [steps])
  const onBack = useCallback(() => setSteps(steps.slice(0, -1)), [steps])
  const onUpdate = useCallback((step) => setSteps([step]), [])

  const activeStep = useMemo(() => steps[steps.length - 1], [steps])

  return [activeStep, onNext, onBack, onUpdate]
}
